/*
 * @Author: gaobin
 * @Date: 2025-01-14 14:15:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-11 11:43:30
 * @Description: 语言国际化
 */

import { CUR_LANGUAGE } from '@/store/mutation-types';
import { createI18n } from 'vue-i18n';

// 国际化 json 文件
import arLocale from './ar.json';
import enLocale from './en.json';

export const LANGUAGE_CODE = {
  en: 'en',
  ar: 'ar',
};

// 当前语言包集合
export const languages = {
  [LANGUAGE_CODE.en]: {
    ...enLocale,
  },
  [LANGUAGE_CODE.ar]: {
    ...arLocale,
  },
};

/**
 * 获取当前系统语言
 * @returns
 */
export function getLanguage() {
  // 获取已设置的语言
  return uni.getStorageSync(CUR_LANGUAGE) || LANGUAGE_CODE.ar;
}

export const localLanguage = getLanguage();

export const i18n = createI18n({
  // 如果要支持compositionAPI，此项必须设置为false
  legacy: false,
  // 语言标识
  locale: localLanguage,
  // 设置默认语言环境
  fallbackLocale: LANGUAGE_CODE.ar,
  // 设置全局本地语言包
  messages: languages,
});

// 语言包的变量替换功能
export function i18ntReplaceVal(key, values) {
  const tValue = i18n.global.t(key);
  if (typeof values === 'string' || typeof values === 'number') {
    return tValue.replace('%s', values);
  } else if (values instanceof Array) {
    let str = tValue;
    for (const item of values) {
      str = str.replace('%s', item);
    }
    return str;
  } else {
    return tValue;
  }
}

/**
 * 对一些语言变量的配置和语言重设
 */
export function setLanguage(curLocale) {
  // uni 切换语言（切换tabbar和页面导航的语言）

  uni.setLocale(curLocale || LANGUAGE_CODE.ar);

  i18n.global.locale.value = curLocale;
  i18n.global.i18ntReplaceVal = i18ntReplaceVal;
}
